// Mock data for development/fallback when API is unavailable
import IMAGES from '../constants/images';

// Function to get translated services
export const getMockServices = (t) => [
  {
    id: 'residential-carpet-cleaning',
    title: t('serviceItems.residentialCarpet.title'),
    description: t('serviceItems.residentialCarpet.description'),
    longDescription: t('serviceItems.residentialCarpet.longDescription'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/residential-carpet-cleaning.jpg',
    category: 'residential',
    features: [
      t('serviceItems.residentialCarpet.features.steamCleaning'),
      t('serviceItems.residentialCarpet.features.ecoFriendly'),
      t('serviceItems.residentialCarpet.features.stainPre'),
      t('serviceItems.residentialCarpet.features.petSafe'),
      t('serviceItems.residentialCarpet.features.fastDrying'),
      t('serviceItems.residentialCarpet.features.allergenRemoval')
    ]
  },
  {
    id: 'commercial-carpet-cleaning',
    title: t('serviceItems.commercialCarpet.title'),
    description: t('serviceItems.commercialCarpet.description'),
    longDescription: t('serviceItems.commercialCarpet.longDescription'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_29821-scaled.jpg',
    category: 'commercial',
    features: [
      t('serviceItems.commercialCarpet.features.afterHours'),
      t('serviceItems.commercialCarpet.features.minimalDisruption'),
      t('serviceItems.commercialCarpet.features.professionalGrade'),
      t('serviceItems.commercialCarpet.features.flexibleScheduling'),
      t('serviceItems.commercialCarpet.features.fastDryingTech'),
      t('serviceItems.commercialCarpet.features.maintenancePrograms')
    ]
  },
  {
    id: 'upholstery-cleaning',
    title: t('serviceItems.upholstery.title'),
    description: t('serviceItems.upholstery.description'),
    longDescription: t('serviceItems.upholstery.longDescription'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_4969-scaled.jpeg',
    category: 'residential',
    videos: ['https://landing.it-tech.name/wp-content/uploads/2025/11/upholstery-cleaning-video.mp4'],
    features: [
      t('serviceItems.upholstery.features.allFabrics'),
      t('serviceItems.upholstery.features.stainRemoval'),
      t('serviceItems.upholstery.features.odorElimination'),
      t('serviceItems.upholstery.features.fabricProtection')
    ]
  },
  {
    id: 'pet-stain-removal',
    title: t('serviceItems.petStain.title'),
    description: t('serviceItems.petStain.description'),
    longDescription: t('serviceItems.petStain.longDescription'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/pet-stains-odor-cleaning.jpg',
    category: 'specialized',
    features: [
      t('serviceItems.petStain.features.enzymatic'),
      t('serviceItems.petStain.features.odorNeutralization'),
      t('serviceItems.petStain.features.deepPenetration'),
      t('serviceItems.petStain.features.permanentRemoval'),
      t('serviceItems.petStain.features.petSafeProducts')
    ]
  },
  {
    id: 'grout-tile-cleaning',
    title: t('serviceItems.groutTile.title'),
    description: t('serviceItems.groutTile.description'),
    longDescription: t('serviceItems.groutTile.longDescription'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/reception-hall-straight-scaled.jpg',
    category: 'specialized',
    features: [
      t('serviceItems.groutTile.features.highPressure'),
      t('serviceItems.groutTile.features.groutRestoration'),
      t('serviceItems.groutTile.features.colorRestoration'),
      t('serviceItems.groutTile.features.moldRemoval'),
      t('serviceItems.groutTile.features.longLasting')
    ]
  },
  {
    id: 'flood-emergency-water-damage',
    title: t('serviceItems.floodEmergency.title'),
    description: t('serviceItems.floodEmergency.description'),
    longDescription: t('serviceItems.floodEmergency.longDescription'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_20251101_124858-scaled.jpg',
    videos: [
      'https://landing.it-tech.name/wp-content/uploads/2025/11/VID_20251101_124858.mp4',
      'https://landing.it-tech.name/wp-content/uploads/2025/11/VID_20251101_124858-2.mp4'
    ],
    videoPoster: 'https://landing.it-tech.name/wp-content/uploads/2025/11/aplogoproposal.png',
    category: 'emergency',
    is24_7: true,
    features: [
      t('serviceItems.floodEmergency.features.available247'),
      t('serviceItems.floodEmergency.features.rapidResponse'),
      t('serviceItems.floodEmergency.features.waterExtraction'),
      t('serviceItems.floodEmergency.features.structuralDrying'),
      t('serviceItems.floodEmergency.features.moldPrevention'),
      t('serviceItems.floodEmergency.features.damageDocumentation')
    ]
  },
  {
    id: 'duct-cleaning',
    title: t('serviceItems.ductCleaning.title'),
    description: t('serviceItems.ductCleaning.description'),
    longDescription: t('serviceItems.ductCleaning.longDescription'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/clean-duct-scaled.jpg',
    category: 'specialized',
    features: [
      t('serviceItems.ductCleaning.features.completeSystem'),
      t('serviceItems.ductCleaning.features.improvedAir'),
      t('serviceItems.ductCleaning.features.energyBoost'),
      t('serviceItems.ductCleaning.features.allergenRemoval'),
      t('serviceItems.ductCleaning.features.beforeAfter'),
      t('serviceItems.ductCleaning.features.hvacOptimization'),
      t('serviceItems.ductCleaning.features.dryerVents')
    ]
  },
  {
    id: 'electrostatic-cleaning',
    title: t('serviceItems.electrostatic.title'),
    description: t('serviceItems.electrostatic.description'),
    longDescription: t('serviceItems.electrostatic.longDescription'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/ElectroStatic-Cleaning-AP-Pacific.png',
    category: 'specialized',
    features: [
      t('serviceItems.electrostatic.features.coverage360'),
      t('serviceItems.electrostatic.features.epaApproved'),
      t('serviceItems.electrostatic.features.germElimination'),
      t('serviceItems.electrostatic.features.hardToReach'),
      t('serviceItems.electrostatic.features.nonToxic'),
      t('serviceItems.electrostatic.features.highTraffic')
    ]
  },
  {
    id: 'area-rugs-cleaning',
    title: t('serviceItems.areaRugs.title'),
    description: t('serviceItems.areaRugs.description'),
    longDescription: t('serviceItems.areaRugs.longDescription'),
    image: 'https://landing.it-tech.name/wp-content/uploads/2025/11/area-rug-cleaning.jpg',
    category: 'residential',
    features: [
      t('serviceItems.areaRugs.features.allRugTypes'),
      t('serviceItems.areaRugs.features.gentleCleaning'),
      t('serviceItems.areaRugs.features.colorPreservation'),
      t('serviceItems.areaRugs.features.fringeCare'),
      t('serviceItems.areaRugs.features.pickupDelivery'),
      t('serviceItems.areaRugs.features.expertInspection')
    ]
  }
];

// Keep the static mockServices export for backward compatibility
// Note: This returns English keys. Components should use getMockServices(t) instead.
export const mockServices = [];

// Function to get translated testimonials
export const getMockTestimonials = (t) => [
  {
    id: 1,
    name: t('mockData.testimonials.testimonial1.name'),
    company: t('mockData.testimonials.testimonial1.company'),
    text: t('mockData.testimonials.testimonial1.text'),
    rating: 5,
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop'
  },
  {
    id: 2,
    name: t('mockData.testimonials.testimonial2.name'),
    company: t('mockData.testimonials.testimonial2.company'),
    text: t('mockData.testimonials.testimonial2.text'),
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
  },
  {
    id: 3,
    name: t('mockData.testimonials.testimonial3.name'),
    company: t('mockData.testimonials.testimonial3.company'),
    text: t('mockData.testimonials.testimonial3.text'),
    rating: 5,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
  }
];

// Keep static export for backward compatibility
export const mockTestimonials = [];

// Function to get translated industries
export const getMockIndustries = (t) => [
  {
    id: 1,
    name: t('mockData.industries.airline.name'),
    description: t('mockData.industries.airline.description'),
    icon: IMAGES.industries.airline
  },
  {
    id: 2,
    name: t('mockData.industries.school.name'),
    description: t('mockData.industries.school.description'),
    icon: IMAGES.industries.school
  },
  {
    id: 3,
    name: t('mockData.industries.autoMobile.name'),
    description: t('mockData.industries.autoMobile.description'),
    icon: IMAGES.industries.autoMobile
  },
  {
    id: 4,
    name: t('mockData.industries.medical.name'),
    description: t('mockData.industries.medical.description'),
    icon: IMAGES.industries.medical
  },
  {
    id: 5,
    name: t('mockData.industries.fitness.name'),
    description: t('mockData.industries.fitness.description'),
    icon: IMAGES.industries.fitness
  },
  {
    id: 6,
    name: t('mockData.industries.entertainment.name'),
    description: t('mockData.industries.entertainment.description'),
    icon: IMAGES.industries.entertainment
  }
];

// Keep static export for backward compatibility
export const mockIndustries = [];

// Company contact information
export const companyInfo = {
  name: 'A.P.Pacific Inc.',
  foundedYear: 1990,
  slogan: 'Clean. Protect. Renew — Experience the A.P. Pacific Difference.',
  subheadline: 'Trusted since 1990, we bring advanced cleaning techniques and genuine care to every carpet, rug, and upholstery we touch — helping them look and feel new for years.',
  phones: ['(450) 687-9220', '(514) 816-9220'],
  email: 'info@appacific.ca',
  website: 'http://www.appacific.ca',
  serviceAreas: ['Montreal', 'Laval', 'South Shore'],
  hours: 'Monday - Saturday: 12:00 AM - 11:59 PM',
  emergency24_7: true
};

// Function to get translated quality features
export const getQualityFeatures = (t) => [
  {
    id: 1,
    title: t('mockData.qualityFeatures.fastService.title'),
    description: t('mockData.qualityFeatures.fastService.description'),
    icon: IMAGES.ui.features.fastService
  },
  {
    id: 2,
    title: t('mockData.qualityFeatures.highTrainedStaff.title'),
    description: t('mockData.qualityFeatures.highTrainedStaff.description'),
    icon: IMAGES.ui.features.highTrainedStaff
  },
  {
    id: 3,
    title: t('mockData.qualityFeatures.qualityCleaning.title'),
    description: t('mockData.qualityFeatures.qualityCleaning.description'),
    icon: IMAGES.ui.features.qualityCleaningStaff
  },
  {
    id: 4,
    title: t('mockData.qualityFeatures.availability247.title'),
    description: t('mockData.qualityFeatures.availability247.description'),
    icon: IMAGES.logos.badge24_7
  }
];

// Keep static export for backward compatibility
export const qualityFeatures = [];
